import React from 'react';
import { Popover, Typography, Button, Box } from '@mui/material';

interface DeleteConfirmationPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onDelete: () => void;
  chartName: string;
}

export const DeleteConfirmationPopover: React.FC<DeleteConfirmationPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  onDelete,
  chartName,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="body1">
          Are you sure you want to delete {chartName}?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={onClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button onClick={onDelete} color="error" variant="contained">
            Delete
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default DeleteConfirmationPopover; 